import React, { useState, useEffect } from "react";
import css from './CustomListingsDisplay.module.css';
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useRouteConfiguration } from "../../context/routeConfigurationContext";
import SearchResultsPanel from "../../containers/SearchPage/SearchResultsPanel/SearchResultsPanel";
import { postQueryListings } from "../../util/api";
import Button from "../Button/Button";
import Spinner from "../IconSpinner/IconSpinner";
import { FormattedMessage } from "react-intl";

export const makeItemList = ({ name, pageUrl, urls }) => ({
    "@type": "ItemList",
    "name": `${name} paddles`,
    "itemListOrder": "http://schema.org/ItemListOrderAscending",
    "numberOfItems": urls.length,
    "url": pageUrl,
    "itemListElement": urls.map((u, i) => ({
        "@type": "ListItem",
        "position": i + 1,
        "url": u,
    })),
});

export const makeAggregateOffer = ({ prices, currency, pageUrl }) => {
    const nums = prices.filter(n => Number.isFinite(n));
    const low = nums.length ? Math.min(...nums) : undefined;
    const high = nums.length ? Math.max(...nums) : undefined;
    return {
        "@type": "AggregateOffer",
        "priceCurrency": currency,
        ...(low != null ? { "lowPrice": Number((low / 100).toFixed(2)) } : {}),
        ...(high != null ? { "highPrice": Number((high / 100).toFixed(2)) } : {}),
        "offerCount": nums.length,
        "url": pageUrl,
    };
};

const CustomListingsDisplay = (props) => {
    const { search, setItems } = props;

    const [listings, setListings] = useState([])
    const [loading, setLoading] = useState(false)

    const location = useLocation();
    const history = useHistory();
    const routeConfiguration = useRouteConfiguration();

    function getUrlParams(queryString) {
        queryString = queryString.startsWith('?') ? queryString.slice(1) : queryString;

        const pairs = queryString.split('&');
        const params = {};

        for (const pair of pairs) {
            const [key, value] = pair.split('=');
            const decodedKey = decodeURIComponent(key);
            let decodedValue = decodeURIComponent(value || '');

            if (decodedKey === 'price') {
                decodedValue = decodedValue
                    .split(',')
                    .map(v => (parseFloat(v) * 100).toString())
                    .join(',');
            }

            params[decodedKey] = decodedValue;
        }

        return params;
    }

    const fetchListings = async () => {
        try {
            setLoading(true);
            const params = getUrlParams(search)
            const response = await postQueryListings({ params });
            const getRelationshipFromIncluded = (relationshipId) => {
                return response.data.included.find(({ id }) => id.uuid === relationshipId)
            }
            const listings = response.data.data.map(listing => {
                const { relationships, ...otherListingFields } = listing;
                const images = relationships.images.data.map(image => getRelationshipFromIncluded(image.id.uuid));
                const author = getRelationshipFromIncluded(relationships?.author?.data?.id?.uuid)
                const currentStock = getRelationshipFromIncluded(relationships?.currentStock?.data?.id?.uuid)
                return {
                    ...otherListingFields,
                    images,
                    author,
                    currentStock,
                };
            })
            setListings(listings);
            // Set items for schema extras
            setItems(listings);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching listings:", error);
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchListings()
    }, [search]);

    return <div className={css.container}>
        {loading ? <div className={css.centerAlign}>
            <Spinner />
        </div> :
            listings.length > 0 ? <>
                <SearchResultsPanel
                    className={css.searchListingsPanel}
                    listings={listings}
                    isMapVariant={false}
                    location={location}
                    history={history}
                    routeConfiguration={routeConfiguration}
                />
                <Button onClick={() => {
                    history.push(`/s?${search}`);
                }}><FormattedMessage id="CustomListingsDisplay.viewMore" /></Button>
            </> : <div className={css.centerAlign}>
                <p><FormattedMessage id="CustomListingsDisplay.noResultsFound" /></p>
                <Button onClick={() => {
                    history.push("/s");
                }}><FormattedMessage id="CustomListingsDisplay.viewOtherPaddles" /></Button>
            </div>
        }

    </div>
};

export default CustomListingsDisplay;